module.exports = ".form-control {\n  font-size: 16px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/change-password/change-password.component.scss
// module id = ./src/app/change-password/change-password.component.scss
// module chunks = main